import React from 'react';
import { Select, MenuItem, Typography, FormControl, SelectChangeEvent, Box } from '@mui/material';
import { PracticeProvider } from 'pages/Dashboard/types/providers.types';
import Theme from 'theme';
import { useHttp } from 'hooks/use-fetch';

interface PatientDropdownProps {
  providers: PracticeProvider[]; // You can pass the list of patients as a prop
  selectedProvider: string;
  setSelectedProvider: (provider:string) => void;
}

function SelectProvider({
  providers,
  selectedProvider,
  setSelectedProvider,
}: PatientDropdownProps) {
  const { setSelectedProviderName, setSelectedProviderId } = useHttp();
  const handleChange = (event: SelectChangeEvent<string>) => {
    setSelectedProviderId(event.target.value);
    setSelectedProvider(event.target.value);
    const selectedProviderObj = providers.find((provider) => provider.id === event.target.value);
    if (selectedProviderObj) {
      setSelectedProviderName(`${selectedProviderObj.firstName} ${selectedProviderObj.lastName}`);
    }
  };

  return (
    <Box style={styles.container}>
      <Typography variant='body1' style={styles.label}>
        Clinician:
      </Typography>
      <FormControl variant='outlined' size='small' style={styles.selectControl}>
        <Select
          labelId='patient-select-label'
          value={selectedProvider || 'all'}
          onChange={handleChange}
          style={styles.selectControl}
          defaultValue='all'
          defaultChecked
        >
          {providers.map((provider) => (
            <MenuItem key={provider.id} value={provider.id}>
              {`${provider.firstName} ${provider.lastName}`}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
  },
  label: {
    fontSize: '16px',
    color: Theme.custom.colors.lightTextSecondary,
  },
  selectControl: {
    minWidth: '200px',
    backgroundColor: '#fff',
  },
};

export default SelectProvider;
